import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"

const statusVariants = cva(
  "rounded-base border px-4 py-3 text-body-sm shadow-outline/0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand",
  {
    variants: {
      variant: {
        info: "border-border-subtle bg-background-muted text-foreground",
        success: "border-success text-success bg-success-soft",
        warning: "border-warning text-warning bg-warning-soft",
        error: "border-danger text-danger bg-danger-soft",
      },
      align: {
        left: "text-left",
        center: "text-center",
      },
    },
    defaultVariants: {
      variant: "info",
      align: "left",
    },
  },
)

export interface StatusMessageProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof statusVariants> {}

export const StatusMessage = React.forwardRef<HTMLDivElement, StatusMessageProps>(
  ({ className, variant, align, ...props }, ref) => (
    <div
      ref={ref}
      role="status"
      className={cn(statusVariants({ variant, align }), className)}
      {...props}
    />
  ),
)
StatusMessage.displayName = "StatusMessage"
